import { gql } from 'apollo-angular';

export var add_project_disclosure = gql`
  mutation addProjectDisclosure(
    $project_id: ID!
    $disclosures: String!
    $milestone_id: ID!
  ) {
    disclosure: addProjectDisclosure(
      project_id: $project_id
      disclosures: $disclosures
      milestone_id: $milestone_id
    ) {
      id
      disclosures
      milestone_id
    }
  }
`;
